module.exports = __webpack_public_path__ + "static/media/bottle-stack.396e2429.png";